<template>
  <div class="sticky">
    <div class="itemsheader" style="overflow:visible;">
      <div class="item opdrlistopdrachtnummer" style="opacity: 1;min-width: 160px;max-width:200px;">
        <span class="tekst">Opdrachtnummer</span>
      </div>
      <div class="item opdrlistbedrijfsnaam" style="min-width:200px;">
        <span class="tekst">Bedrijfsnaam</span>
      </div>
      <div class="item opdrlistdisciplines" style="min-width:200px;">
        <span class="tekst">Discipline</span>
      </div>
      <div class="item opdrliststatus" style="opacity: 1;max-width:190px;">
        <span class="tekst">Status</span>
      </div>
      <div class="item opdrlisttekenaar" style="opacity: 1;min-width:220px;">
        <span class="tekst">Tekenaar</span>
      </div>
      <div class="item taa">
        <span v-for="(x, i) in items" :key="i" class="voortgangtitel">{{ x }}</span>
      </div>
    </div>

    <div class="filterbar">
      <div class="item opdrlistopdrachtnummer" style="opacity: 1;min-width: 160px;max-width:200px;transform:translateX(-10px);">
        <SearchfieldWithReset :filterOn="opdrFilters.opdrachtnummer" filterBy="opdrachtnummer" />
      </div>
      <div class="item opdrlistbedrijfsnaam" style="min-width:200px; width:23%;transform:translateX(-10px);">
        <SearchfieldWithReset :filterOn="opdrFilters.bedrijfsnaam" filterBy="bedrijfsnaam" />
      </div>
      <div class="item opdrlistdisciplines" style="min-width:200px; width:22%;transform:translateX(-70px);">
        <!-- <div class="discholder" style="margin-top:30px;margin-left:-3px;">
          <DropdownSelect2
            :filterOn="opdracht[0].disciplines"
            @update="(opdracht[0].disciplines = $event), (isOpdrachtEdited = true)"
            :class="{
              pastel1: opdracht[0].disciplines == 'Bouwkunde',
              pastel2: opdracht[0].disciplines == 'Werktuigbouwkunde',
              pastel3: opdracht[0].disciplines == 'Installatietechniek',
              pastel4: opdracht[0].disciplines == 'Elektrotechniek',
              pastel5: opdracht[0].disciplines == 'Huisvesting',
              pastel6: opdracht[0].disciplines == 'Plattegronden',
              pastel7: opdracht[0].disciplines == 'Concepten - 3D Print',
              pastel8: opdracht[0].disciplines == 'Brandpreventie',
              pastel9: opdracht[0].disciplines == 'Nen2580'
            }"
          />
        </div> -->
        <DropdownSelect2
          :class="{
            pastel0: opdrFilters.disciplines == '',
            pastel1: opdrFilters.disciplines == 'Bouwkunde',
            pastel2: opdrFilters.disciplines == 'Werktuigbouwkunde',
            pastel3: opdrFilters.disciplines == 'Installatietechniek',
            pastel4: opdrFilters.disciplines == 'Elektrotechniek',
            pastel5: opdrFilters.disciplines == 'Huisvesting',
            pastel6: opdrFilters.disciplines == 'Plattegronden',
            pastel7: opdrFilters.disciplines == 'Concepten - 3D Print',
            pastel8: opdrFilters.disciplines == 'Brandpreventie',
            pastel9: opdrFilters.disciplines == 'Nen2580'
          }"
          :filterOn="opdrFilters.disciplines"
          filterBy="disciplines"
        />
      </div>
      <div class="item opdrliststatus" style="opacity: 1;min-width:220px;transform:translateX(-120px);">
        <SearchfieldWithReset :filterOn="opdrFilters.status" filterBy="status" />
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../../store"
import SearchfieldWithReset from "./SearchfieldWithReset"
// import DropdownSelect from './DropdownSelect';
import DropdownSelect2 from "./DropdownSelect2"

export default {
  name: "ItemsHeader",
  setup() {
    const items = ["Nieuw", "In behandeling", "Uitgezet", "Geaccepteerd", "Intake", "Lopend", "Gefactureerd"]
    return { items }
  },
  components: {
    SearchfieldWithReset,
    // DropdownSelect,
    DropdownSelect2
  },
  computed: {
    showOpdrFilters() {
      return store.state.showOpdrFilters
    },
    opdrFilters() {
      return store.state.opdrFilters
    }
  }
}
</script>

<style lang="sass" scoped>
.taa
  overflow: visible !important
  display: flex !important
  justify-content: space-around !important
  align-items: center !important

  position: relative
  > .voortgangtitel
    position: absolte
    width: 14px
    font-size: 14px
    white-space: nowrap
    transform-origin: top left
    transform: rotate(-90deg) translateX(-22px)
</style>

<style scoped>
.pastel0 {
  background-color: #bbb;
}
.sticky {
  position: sticky;
  top: 100px;
  z-index: 1;
}
.itemsheader {
  /* border-top-left-radius: 5px;
    border-top-right-radius: 5px; */
  padding: 25px 25px;
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #e4ecfa;
  border: 1px solid #c5d8e3;
}

.filterbar {
  padding: 0px 25px;
  padding-bottom: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #e4ecfa;
  margin-top: -1px;
  border-top: 1px solid #e4ecfa;
  border-bottom: 1px solid #c5d8e3;
  border-left: 1px solid #c5d8e3;
  border-right: 1px solid #c5d8e3;
}
.opdrliststatus {
  overflow: inherit !important;
}
.item {
  opacity: 1;
  display: flex;
  overflow: hidden;
  align-items: center;
  min-width: 160px;
  width: 25%;
}

.tekst {
  white-space: nowrap;
  color: #0b1125;
}
</style>
